import React from 'react';
import './Die.scss';
import { selectIsRollingDice } from '../../redux/animationSlice';
import { useSelector, useDispatch } from 'react-redux';
import { selectCurrentTurnPlayer, selectIsMyTurn, requestMarkDie, selectDiceRoll, selectRollsLeft } from '../../redux/gameSlice';
import { getExtraDiceCount } from '../../playerUtils';

const faceClassByDieNum = {
    1: "show-front",
    2: "show-back",
    3: "show-left",
    4: "show-right", // Heart: 4
    5: "show-bottom", // Damage: 5
    6: "show-top" // Energy: 6
};

export default function Die(props) {
    const curTurnPlayer = useSelector(selectCurrentTurnPlayer);
    const isMyTurn = useSelector(selectIsMyTurn);
    const diceRoll = useSelector(selectDiceRoll);
    const isRolling = useSelector(selectIsRollingDice);
    const rollsLeft = useSelector(selectRollsLeft);
    const isDieMarkedForRoll = useSelector(state => state.game.rollDiceAtPos[props.pos]);
    const isDisabled = getExtraDiceCount(curTurnPlayer) < props.pos - 5;
    const isExtra = props.isExtraDie;

    const dispatch = useDispatch();
    const selectDie = () => {
        if (isRolling === true || isMyTurn === false || rollsLeft === 0 || isDisabled === true) {
            // Cannot select die while rolling or if the die is not ours
            return;
        }

        dispatch(requestMarkDie({
            pos: props.pos,
            mark: !isDieMarkedForRoll
        }));
    }

    const number = diceRoll[props.pos];
    let extraClasses = [faceClassByDieNum[number]];
    if (isDisabled) {
        extraClasses.push("game-sprite die-disabled");
    }

    if (isDieMarkedForRoll) {
        extraClasses.push("die-selected");
    }

    if (isExtra) {
        extraClasses.push("extra-die");
    }

    const faceClass = props.hasEffect === false || isDisabled ? "face face-has-no-effect" : "face";

    return <div className={`die ${extraClasses.join(" ")}`} onClick={selectDie}>
        <div className={faceClass}>
            <div className="game-sprite face-image face-1"></div>
        </div>
        <div className={faceClass}>
            <div className="game-sprite face-image face-2"></div>
        </div>
        <div className={faceClass}>
            <div className="game-sprite face-image face-3"></div>
        </div>
        <div className={faceClass}>
            <div className="game-sprite face-image face-heart"></div>
        </div>
        <div className={faceClass}>
            <div className="game-sprite face-image face-energy"></div>
        </div>
        <div className={faceClass}>
            <div className="game-sprite face-image face-damage"></div>
        </div>
    </div>;
}
